import React from "react";
import { Input } from "@elaniintc/goes-design-system";
import { maskitoTimeOptionsGenerator } from "@maskito/kit";
import { useMaskito } from "@maskito/react";
import { cn } from "@/utils/theme";

interface Props {
  value: string;
  onChange: (value: string) => void;
  shouldUse24: boolean;
  group?:
    | "down"
    | "down-left"
    | "down-right"
    | "left"
    | "right"
    | "up"
    | "up-left"
    | "up-right"
    | "single"
    | "middle"
    | "middle-right"
    | "middle-left"
    | "middle-up";
  placeholder?: string;
  wrapperClassName?: string;
  className?: string;
  toggleMerdian?: () => void;
}

const TimeInput = ({
  value,
  onChange,
  group,
  shouldUse24,
  placeholder = "Horas y minutos",
  wrapperClassName,
  className,
}: Props) => {
  const timeFormat = shouldUse24 ? "HH:MM" : "HH:MM AA";

  const maskRef = useMaskito({
    options: maskitoTimeOptionsGenerator({
      mode: timeFormat,
      timeSegmentMaxValues: {
        hours: shouldUse24 ? 23 : 12,
        minutes: 59,
      },
    }),
  });

  const inputRef = React.useRef<HTMLInputElement | null>(null);

  const combinedRef = React.useCallback(
    (el: HTMLInputElement | null) => {
      inputRef.current = el;
      maskRef(el);
      if (el && (value === "" || value == null)) {
        el.value = "";
      }
    },
    [maskRef, value],
  );

  React.useEffect(() => {
    if (inputRef.current) {
      if (value === "" || value == null) {
        inputRef.current.value = "";
      } else if (inputRef.current.value !== value) {
        inputRef.current.value = value;
      }
    }
  }, [value]);

  return (
    <div className={cn("relative w-full", wrapperClassName)}>
      <Input
        className={cn("w-full", className)}
        group={group}
        placeholder={placeholder}
        value={value ?? ""}
        ref={combinedRef}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default TimeInput;
